import { Resources } from '../ui/resources';

export function isValidJsonString(string: string): boolean {
    try {
        JSON.parse(string);
    } catch (e) {
        return false;
    }
    return true;
}

export function isScopeAction(actionType: string): boolean {
    if (actionType === Resources.ACTION_TYPE_SCOPE || actionType === Resources.ACTION_TYPE_CONDITION || actionType === Resources.ACTION_TYPE_FOREACH
         || actionType === Resources.ACTION_TYPE_UNTIL || actionType === Resources.ACTION_TYPE_SWITCH) {
        return true;
    }
    return false;
}